module.exports = __webpack_public_path__ + "img/eco-positive-without-symptons.43c07eda.png";